import { MUIButton, MUITooltip } from "@abb/arcadia-ui-react"
import { useCallback, useContext } from "react"
import { useNavigate } from "react-router-dom"
import { UserContext } from "../../context/UserContext"
import {
  AccessLevel,
  DimaFeature,
  hasUserAccessToApplicationFeature,
  hasUserAccessToFeature,
} from "../../models/Authorization"
import { Guid } from "../../models/CustomType"

export function DiMaAddButton({
  url,
  feature,
  applicationId,
  requireCreateLevel = false,
}: {
  readonly url: string
  readonly feature: string
  readonly applicationId?: Guid
  readonly requireCreateLevel?: boolean
}) {
  const navigate = useNavigate()
  const { user } = useContext(UserContext)

  const requiredAccess = requireCreateLevel ? AccessLevel.Create : AccessLevel.Write

  const hasAccess = applicationId
    ? user &&
      hasUserAccessToApplicationFeature(
        user.authorizations.applications,
        applicationId,
        feature,
        requiredAccess
      )
    : user && hasUserAccessToFeature(user.authorizations, feature, requiredAccess)

  const accessLevelLabel = requireCreateLevel ? "create" : "write"
  const applicationLabel = applicationId ? " for this application" : ""
  const tooltipText = hasAccess
    ? ""
    : `You do not have ${accessLevelLabel} access to ${
        DimaFeature[feature]
      } feature${applicationLabel}.`

  const handleClick = useCallback(() => {
    if (hasAccess) {
      navigate(url)
    }
  }, [hasAccess, navigate, url])

  return (
    <MUITooltip tooltipText={tooltipText} position="top">
      <MUIButton
        variant="primary"
        iconName="icon-abb_add-small icon_abb_dias"
        label="Add"
        size={32}
        disabled={!hasAccess}
        aria-label="Add new item"
        onClickButton={handleClick}
      />
    </MUITooltip>
  )
}
